var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatMap1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 168,
    viewBox: "0 0 89 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_1693_26267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 34.0001V24.9078C17.5 13.1216 23.8268 4.44106 35.6122 4.57982C43.4678 4.6723 52.5141 5.16702 59.9422 5.64484C67.2245 6.11326 73.1306 11.7539 74 18.9992L77.8681 57.6805C78.2887 61.8863 78.3477 66.1147 78.2705 70.3409C78.0206 84.0254 78.9172 107.829 84 128.499C89.5103 150.908 50.8808 161.256 32.7907 163.57C30.0281 163.924 27.2954 163.032 25.1243 161.287L10.9668 149.911C7.48812 147.115 8.53729 137 13 137C18.2877 137 22.621 132.789 22.6859 127.502C22.7521 122.113 22.7415 116.691 22.5 115C21.3333 106.833 17.5 99.1665 17.5 90.9167V76.5002V61.0001V34.0001Z",
    fill: "#4A9FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5312 32.9086V29.3394C28.5312 20.9632 33.1538 14.8981 41.5291 15.0182C47.0001 15.0967 53.2145 15.4152 58.1869 15.7078C62.6338 15.9695 66.2648 19.3669 66.8555 23.7821L69.1235 44.1242C69.6454 48.8055 69.7066 53.5232 69.7282 58.2334C69.7674 66.7587 70.6006 79.3202 73.6386 90.4015C76.9664 102.54 73.9488 121.564 67.1138 128.431C64.4685 131.089 60.5979 132.57 58.1006 135.367C49.9389 144.508 36.1857 139.886 34.3998 127.762C33.6774 122.858 32.9773 118.145 32.4659 114.292C31.7808 109.131 31.9228 100.78 31.9228 95.5734C32.0358 91.8216 32.1941 83.8922 31.9228 82.1887C31.1205 77.1512 28.5312 72.4865 28.5312 67.3855V58.7654V49.3353V32.9086Z",
    fill: "url(#paint0_linear_1693_26267)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1693_26267",
    x: 4.89453,
    y: 0.578125,
    width: 83.6387,
    height: 167.068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1693_26267"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1693_26267",
    x1: 52,
    y1: 1.5,
    x2: 51.7642,
    y2: 159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#FFE70B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447075,
    stopColor: "#FF371E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850203,
    stopColor: "#6CDD59"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap1);
export default __webpack_public_path__ + "static/media/heatMap1.7a5c723943d53ae0626556916a68353b.svg";
export { ForwardRef as ReactComponent };